import WEBAPI from '@/services/WEBAPI';

const CAPTCHA_VALUE_PARAM = 'param';

export const normalizePublicFormLanguage = (language) =>
  language === 'gr' ? 'el' : language || 'en';

const findApplicationTypeByCode = (applicationTypes, code) => {
  if (!code) return null;

  return (applicationTypes || []).find((applicationType) => {
    const possibleCodes = [
      applicationType?.code,
      applicationType?.name,
      applicationType?.id,
      applicationType?.slug,
    ].filter(Boolean);

    return possibleCodes.some(
      (possibleCode) => String(possibleCode) === String(code)
    );
  });
};

export const buildPublicFormUrl = ({
  publicApplicationType,
  deeplinkMeta,
  recaptchaToken,
}) => {
  const captchaKey = process.env.REACT_APP_NV_CAPTCHA_KEY;
  const url = new URL(publicApplicationType.url);

  url.searchParams.set('nv-captcha-key', captchaKey || '');
  url.searchParams.set('nv-captcha-value-param', CAPTCHA_VALUE_PARAM);
  url.searchParams.set(CAPTCHA_VALUE_PARAM, recaptchaToken || '');

  if (deeplinkMeta?.application_licence_plate) {
    url.searchParams.set(
      'license_plate',
      deeplinkMeta.application_licence_plate
    );
  }

  if (deeplinkMeta?.applications_code) {
    url.searchParams.set('code', deeplinkMeta.applications_code);
  }

  return url;
};

const addBaseHref = (html, responseUrl) => {
  if (!html || !responseUrl || /<base\s/i.test(html)) return html;

  const baseHref = new URL(responseUrl).origin;
  const baseTag = `<base href="${baseHref}/">`;

  if (/<head[^>]*>/i.test(html)) {
    return html.replace(/<head([^>]*)>/i, `<head$1>${baseTag}`);
  }

  return `${baseTag}${html}`;
};

export const fetchPublicFormHtml = async ({
  publicApplicationType,
  deeplinkMeta,
  recaptchaToken,
}) => {
  const url = buildPublicFormUrl({
    publicApplicationType,
    deeplinkMeta,
    recaptchaToken,
  });

  const response = await fetch(url.toString(), {
    method: 'GET',
    credentials: 'omit',
    redirect: 'follow',
    headers: {
      Accept:
        'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
    },
  });
  const html = await response.text();

  if (!html) {
    throw new Error(`Empty response body (${response.status})`);
  }

  return addBaseHref(html, response.url || url.toString());
};

export const fetchPublicApplicationTypeByLanguage = async ({
  authority,
  language,
  code,
}) => {
  const response = await WEBAPI.getPublicApplicationTypes(
    authority,
    normalizePublicFormLanguage(language)
  );
  const publicApplicationTypes = response.result || [];

  return {
    publicApplicationTypes,
    publicApplicationType: findApplicationTypeByCode(
      publicApplicationTypes,
      code
    ),
  };
};
